/* src/app/workshop/components/settings/settings/settings.component.scss */
.settings-icon {
  border: 2px solid black;
  border-radius: 10px;
  text-align: center;
  background: #fff;
}
.settings-icon:hover {
  border: 2px solid red;
  cursor: pointer;
}
.settings-icon-inactive {
  border: 2px solid #999999;
  border-radius: 10px;
  text-align: center;
  color: #999999;
  background: #ccccccc;
}
.settings-icon-inactive:hover {
  cursor: not-allowed;
}
/*# sourceMappingURL=settings.component.css.map */
